import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchPositionsData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api";
import { IPositionsData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/Forms/OrganizationStructureForm.models";

const useFetchPositionsData = (
  companyId: string,
  structureId: string | undefined,
  query?: string
) => {
  const normalizedQuery = query?.trim();
  const filters = normalizedQuery
    ? `(${normalizedQuery
        .split(/\s+/)
        .map((word) => `value=like=*${word}*`)
        .join(";")})`
    : null;

  return useInfiniteQuery<IPositionsData, Error>({
    queryKey: ["fetch-positions", companyId, structureId, query],
    queryFn: async ({ pageParam, signal }) =>
      fetchPositionsData(companyId, structureId!, {
        signal,
        cursor: pageParam as string | undefined,
        filters,
      }),
    enabled: !!companyId && !!structureId,
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    placeholderData: (previousData) =>
      previousData ?? { pages: [], pageParams: [] },
  });
};

export default useFetchPositionsData;
